import React from 'react'
import { SimpleGrid } from '@chakra-ui/react'
import StatCard from './StatCard'
import { CoinData } from '../types'

interface DevelopmentPanelProps {
  data: CoinData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const DevelopmentPanel = ({ data, gridTemplateColumns, statCardBg }: DevelopmentPanelProps) => (
  <SimpleGrid columns={gridTemplateColumns || 1} spacing={4} mb={6}>
    <StatCard
      bg={statCardBg}
      label="Pull Request Contributors"
      value={data.developer_data.pull_request_contributors.toString()}
    />

    <StatCard
      bg={statCardBg}
      label="Commit Count (4 weeks)"
      value={data.developer_data.commit_count_4_weeks.toString()}
    />

    <StatCard
      bg={statCardBg}
      label="Code Additions (4 weeks)"
      value={data.developer_data.code_additions_deletions_4_weeks.additions.toString()}
    />

    <StatCard
      bg={statCardBg}
      label="Code Deletions (4 weeks)"
      value={data.developer_data.code_additions_deletions_4_weeks.deletions.toString()}
    />
  </SimpleGrid>
)

export default DevelopmentPanel
